export default __webpack_public_path__ + "static/media/gatz.2a82ef35.png";